import { useEffect, useRef } from 'react';

export const useSidebar = () => {
  const lastScrollTop = useRef<number>(0);

  useEffect(() => {
    lastScrollTop.current = document.documentElement.scrollTop;
    const sidebar = document.querySelector('#sidebar') as HTMLElement;

    const TOPBAR_HEIGHT = 64;
    const SPACING = 10;
    const MAX_TOP = TOPBAR_HEIGHT + SPACING;

    const handleScroll = () => {
      if (!sidebar) return;
      const windowHeight = window.innerHeight;
      const sidebarHeight = Math.ceil(sidebar.getBoundingClientRect().height);

      const currentTop = sidebar.style.top
        ? parseInt(sidebar.style.top)
        : MAX_TOP;
      const scrollTop = document.documentElement.scrollTop;

      // Calculating sidebar top height which need to hide when sidebar is larger than window.
      const heightDelta = Math.abs(windowHeight - sidebarHeight) + SPACING;
      // Calculating how much height has been scrolled. Depends upon scroll speed.
      const scrollDelta = lastScrollTop.current - scrollTop;

      const isScrollingDown = scrollTop > lastScrollTop.current;
      const isWindowLarger = windowHeight > sidebarHeight;

      // While scrolling, top value is always between MAX_TOP and -heightDelta
      if (!isWindowLarger) {
        const expectedTop = currentTop + scrollDelta;
        if (isScrollingDown && currentTop > -heightDelta) {
          const top = expectedTop < -heightDelta ? -heightDelta : expectedTop;
          sidebar.style.top = `${top}px`;
        } else if (!isScrollingDown && currentTop < MAX_TOP) {
          const top = expectedTop > MAX_TOP ? MAX_TOP : expectedTop;
          sidebar.style.top = `${top}px`;
        }
      } else if (isWindowLarger && currentTop < MAX_TOP) {
        sidebar.style.top = `${MAX_TOP}px`;
      }

      lastScrollTop.current = scrollTop;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
};
